import { Alert, Snackbar } from '@mui/material';

interface ErrorSnackbarProps {
  error: any;
  onClose: () => void;
}

export function ErrorSnackbar({ error, onClose }: ErrorSnackbarProps) {
  return (
    <Snackbar 
      open={!!error} 
      autoHideDuration={6000} 
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity="error" sx={{ width: '100%' }}>
        {typeof error === 'string' ? error : error?.message || JSON.stringify(error)}
      </Alert>
    </Snackbar>
  );
}